import { ChangeDetectorRef, Component } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { Subscription } from 'rxjs';
import { TerritoriesListItem } from '../../../../Models/TerritoriesListItem';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { TerritoriesService } from '../../../../services/TerritoriesService.service';
import { MapHelperService } from 'src/services/map-helper.service';
import { PanelInternalLayerService } from 'src/app/features/map-features/sections/locations-section/services/Panel-Internal-Layer.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { ToastrService } from 'ngx-toastr';
import { PanelDetailTerritoriesService } from '../../../../services/Panel-Detail-Territories.service';
import { environment } from 'src/environments/environment.test';
import { EstatusJSON } from 'src/app/features/shared/models/EstatusJSON';
import { UnileverService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Unilever.service';
import { MatDialog } from '@angular/material/dialog';
import { TerritoriesFilterPopupComponent } from '../../molecules/territories-filter-popup/territories-filter-popup.component';
import { PanelTerritoriesService } from '../../../../services/Panel-Territories.service';
import { TerritoriesFilters, TerritoriesFiltersSelected } from '../../../../Models/TerritoriesFilters';
import { TerritoryRouteTypeAcronymDisplayEnum, TerritoryRouteTypeColorsEnum, TerritoryRouteTypeEnum } from '../../../../utilities/enums/TerritoriesEnum';
import { TerritoriesLayerControlService } from '../../../../services/TerritoriesLayerControl.service';
import { PanelEditTerritoriesService } from '../../../../services/Panel-Edit-Territories.service';
import { RouteTypeIconPipe } from '../../../../pipes/RouteTypeIcon.pipe';

@Component({
  selector: 'territories-panel',
  templateUrl: './territories-panel.component.html',
  styleUrls: ['./territories-panel.component.css']
})
export class TerritoriesPanelComponent {
  
  

  TerritoryRouteTypeColorsEnum = TerritoryRouteTypeColorsEnum;
  territoryRouteTypeAcronymDisplayEnum = TerritoryRouteTypeAcronymDisplayEnum;
  TerritoryRouteTypeEnumValues = Object.values(TerritoryRouteTypeEnum);
  TerritoryRouteTypeEnum = TerritoryRouteTypeEnum;

  itemsCounter: { [key: string]: number } = {};
  
  public $Items: TerritoriesListItem[] = [];
  public $ItemsBackup: TerritoriesListItem[] = [];
  public $ItemsNoFilterBackup: TerritoriesListItem[] = [];
  finder: string = "";
  public isMapix: boolean = false;
  public isLoading: boolean = true;
  filter: boolean = false;
  selectedItems: Set<string> = new Set();
  PinSelected: any = null;
  isAdmin: boolean;
  roles: string;
  $ItemsActives: TerritoriesListItem[] = [];
  $ItemsInactives: TerritoriesListItem[] = [];
  subscription_GetList: Subscription;
  subscription_getLoading: Subscription;
  subscription_GetFilters: Subscription;
  selectedTabIndex: number = 0;

  territoriesFilters : TerritoriesFilters = {
    Regiones: [],
    Zonas: [],
    TipoRuta: [],
    DiaVisita: [],
    FrecuenciaRuta: []
  };
  selectedFilters: TerritoriesFiltersSelected = {
    Region: { description: "", id: 0 },
    Zona: { description: "", idRegion: 0 },
    TipoRuta: [],
    DiaVisita: [],
    FrecuenciaRuta: []
  };
  areFiltersSelected: boolean = false;
  areAllLayerFiltersActive: boolean = false;
  isLoadingFilters: boolean = false;

  filterDialog = null;


  // dataGeoJson: [];
  centroidesGeoJson: any;
  centroidesGeoJsonBackup: any;
  

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  fullScreen: boolean = false;
  subscription_get: Subscription;
  suscription_GetLayerDataByNameGeoJSON: Subscription;
  subscription_GetAllTerritoriesGeoJson: Subscription;
  subscription_findByIdentifier: Subscription;
  subscription_getVisiblePanelDetailTerritories: Subscription;
  subscription_getVisiblePanelEditTerritories: Subscription;
  
  private centroidLoadTimeout: any = null;
  private centroidLoadTimeoutEdit: any = null;

  
  // isSearchButtonPressed: boolean = false;
  isToolButtonPressed: boolean = true;

  constructor(
    private sessionService: SessionService,
    private panelTerritoriesService: PanelTerritoriesService,
    private territoriesService: TerritoriesService,
    private panelDetailTerritoriesService: PanelDetailTerritoriesService,
    private panelEditTerritoriesService: PanelEditTerritoriesService,
    public layerTerritoriesService: TerritoriesLayerControlService,
    private mapHelperService: MapHelperService,
    changeDetectorRef: ChangeDetectorRef,
    private panelInternalLayerService: PanelInternalLayerService,
    media: MediaMatcher,
    private toastService: ToastrService,
    private unileverService: UnileverService,
    private routeTypeIconPipe: RouteTypeIconPipe,
    private matDialog: MatDialog
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 761px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.subscription_getLoading = this.panelTerritoriesService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });
    
    this.subscription_getVisiblePanelDetailTerritories = this.territoriesService.getVisiblePanelDetailTerritories().subscribe((isVisible: boolean) => {
      if(!isVisible){
        // this.AreAllLayerFiltersActive(this.layerTerritoriesService.filtroDeTerritorios);
        if(this.centroidLoadTimeout) clearTimeout(this.centroidLoadTimeout);
        this.centroidLoadTimeout = setTimeout(() => {
          if(this.centroidesGeoJson)
            this.loadCentroidsGeoJson(this.centroidesGeoJson);
          this.centroidLoadTimeout = null;
        }, 1500);
      }
    });

    this.subscription_getVisiblePanelEditTerritories = this.territoriesService.getVisiblePanelEditTerritories().subscribe((isVisible: boolean) => {
      if(!isVisible){
        if(this.$Items.length > 0){
          if(this.centroidLoadTimeoutEdit) clearTimeout(this.centroidLoadTimeoutEdit);
          this.centroidLoadTimeoutEdit = setTimeout(() => {
            if(this.centroidesGeoJson)
              this.loadCentroidsGeoJson(this.centroidesGeoJson);
            this.centroidLoadTimeoutEdit = null;
          }, 1500);
        }
      }
    });
  }

  ngOnInit(): void {
    this.panelTerritoriesService.setLoading(true);
    this.panelTerritoriesService.initializeLayers();
  }

  ngAfterViewInit(): void {
    this.getTerritoriesList(this.selectedFilters);
    this.getFilters();
    this.checkingURL();
  }


  ngOnDestroy() {
    if (this.subscription_GetList) this.subscription_GetList.unsubscribe();
    if (this.subscription_get) this.subscription_get.unsubscribe();
    if (this.subscription_getLoading)
      this.subscription_getLoading.unsubscribe();
    if (this.suscription_GetLayerDataByNameGeoJSON)
      this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
    if (this.subscription_GetAllTerritoriesGeoJson)
      this.subscription_GetAllTerritoriesGeoJson.unsubscribe();
    if (this.subscription_findByIdentifier)
      this.subscription_findByIdentifier.unsubscribe();
    if (this.subscription_GetFilters)      
      this.subscription_GetFilters.unsubscribe();
    if(this.subscription_getVisiblePanelDetailTerritories)
      this.subscription_getVisiblePanelDetailTerritories.unsubscribe();
    if(this.subscription_getVisiblePanelEditTerritories)
      this.subscription_getVisiblePanelEditTerritories.unsubscribe();

    if(this.filterDialog){
      this.filterDialog.close();
    }

    if(this.centroidLoadTimeout) {
      clearTimeout(this.centroidLoadTimeout);
      this.centroidLoadTimeout = null;
    }
    if(this.centroidLoadTimeoutEdit) {
      clearTimeout(this.centroidLoadTimeoutEdit);
      this.centroidLoadTimeoutEdit = null;
    }

    this.panelTerritoriesService.destroyLayers();
    this.panelTerritoriesService.closeDetailPopUp();
  }
  
  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  onFindTerritory(event) {
    this.panelTerritoriesService.setLoading(true);
    if (!this.mobileQuery.matches) {
      this.fullScreen = true;
    }
    if (!environment.production) console.log(event);
    var texto = event.target ? event.target.value.toLowerCase() : this.finder.toLowerCase();
    if (texto.length == 0) {
      this.filter = false;
      this.$Items = this.$ItemsBackup;
      this.CountRouteTypes();
      if (!environment.production) console.log("reset filter...");
      this.panelTerritoriesService.setLoading(false);
    } else {
      this.filter = true;
      this.$Items = this.$ItemsBackup.filter((item) => {
        return (item.idTerritory.toLowerCase().includes(texto));
      });
      this.CountRouteTypes();
      this.panelTerritoriesService.setLoading(false);
    }
    const layerFilterBackup = JSON.parse(JSON.stringify(this.layerTerritoriesService.filtroDeTerritorios));
    this.layerTerritoriesService.hideAllTerritoryLayers();
    // this.ActivateFilteredLayersAfterGlobalFilter(layerFilterBackup)
  }

  resetFilterValue() {
    this.finder = "";
    this.filter = false;
    this.$Items = this.$ItemsBackup;
    this.CountRouteTypes();
    this.panelTerritoriesService.setLoading(false);
  }

  getTerritoriesList(selectedFilters: TerritoriesFiltersSelected) {
    this.panelTerritoriesService.setLoading(true);

    this.areFiltersSelected = !(selectedFilters.Region.description === "" && selectedFilters.Zona.description === "" && selectedFilters.TipoRuta.length === 0 && selectedFilters.DiaVisita.length === 0 && selectedFilters.FrecuenciaRuta.length === 0);

    if(!this.areFiltersSelected && this.$ItemsNoFilterBackup.length > 0){
      this.$Items = this.$ItemsNoFilterBackup;
      this.$ItemsActives = this.$ItemsNoFilterBackup;
      this.$ItemsBackup = this.$ItemsNoFilterBackup;
      this.centroidesGeoJson = this.centroidesGeoJsonBackup;
      this.panelTerritoriesService.destroyLayers();
      // this.panelTerritoriesService.locationsGeoJson = {};
      this.loadCentroidsGeoJson(this.centroidesGeoJson);
      this.panelTerritoriesService.setLoading(false);

      this.itemsCounter = {};
      this.$Items.forEach(item => {
        this.itemsCounter[item.routeType] = (this.itemsCounter[item.routeType] || 0) + 1;
      });
      return;
    }

    this.subscription_GetList = this.unileverService.GetPlanningTerritoriesFiltered(selectedFilters).subscribe((data: EstatusJSON) => {
      if (data.isSuccess && data.result && data.result.planningTerritoriesFiltered && data.result.planningTerritoriesFiltered.length > 0) {
        this.$Items = [ ...data.result.planningTerritoriesFiltered];
        // this.$Items = [ ...this.dummyData, ...data.result.planningTerritoriesFiltered];
        this.$ItemsActives = this.$Items;
        this.$ItemsBackup = this.$Items;

        const geoJson = JSON.parse(data.result.geoJson || '{}');
        this.centroidesGeoJson = geoJson;

        this.loadCentroidsGeoJson(this.centroidesGeoJson);
        this.CountRouteTypes();

        if (!environment.production) console.log(this.$ItemsActives);
      } else {
        this.toastService.error("Error al obtener los territorios");
        Sentry.captureMessage('TerritoriesPanelComponent.GetPlanningTerritoriesFiltered: isSuccess false', { level: 'warning', extra: { response: data } });

      }
      this.panelTerritoriesService.setLoading(false);
    });
  }

  getFilters(){
    // this.isLoadingFilters = false;
    //     this.territoriesFilters = {
    //       Regiones: [{ description: 'Norte', id: 1 }, { description: 'Sur', id: 2 }, { description: 'Centro', id: 3 }, { description: 'Occidente', id: 4 }, { description: 'Oriente', id: 5 }],
    //       Zonas: [{ description: 'Zona A', idRegion: 1 }, { description: 'Zona B', idRegion: 2 }, { description: 'Zona C', idRegion: 3 }, { description: 'Zona D', idRegion: 4 }],
    //       TipoRuta: ['FR', 'P', 'R'],
    //       DiaVisita: ['L', 'M',  'X', 'J', 'V', 'S', 'D'],
    //       FrecuenciaRuta: ['M1', 'M2', 'M3', 'M4', 'Q1', 'Q2', 'S1', 'S2', 'S3', 'S4']
    //     };
    this.isLoadingFilters = true;

    this.subscription_GetFilters = this.unileverService.PlanningTerritoriesGetFilters().subscribe((data: EstatusJSON) => {
      if (data.isSuccess && data.result) {
        const regiones = data.result.regions.map(region => ({ description: region.description, id: region.id }));
        const zonas = data.result.zones.map(zone => ({ description: zone.description, idRegion: zone.idRegion }));
        const tipoRuta = data.result.routeTypes;
        const diaVisita = data.result.visitDays;
        const frecuenciaRuta = data.result.routeFrecuencies;
        this.territoriesFilters = {
          Regiones: regiones,
          Zonas: zonas,
          TipoRuta: tipoRuta,
          DiaVisita: diaVisita,
          FrecuenciaRuta: frecuenciaRuta
        };
        this.isLoadingFilters = false;  
      }else{
        this.isLoadingFilters = false;
        Sentry.captureMessage('TerritoriesPanelComponent.PlanningTerritoriesGetFilters: isSuccess false', { level: 'warning', extra: { response: data } });
        // this.territoriesFilters = {
        //   Regiones: [{ description: 'Norte', id: 1 }, { description: 'Sur', id: 2 }, { description: 'Centro', id: 3 }, { description: 'Occidente', id: 4 }, { description: 'Oriente', id: 5 }],
        //   Zonas: [{ description: 'Zona A', idRegion: 1 }, { description: 'Zona B', idRegion: 2 }, { description: 'Zona C', idRegion: 3 }, { description: 'Zona D', idRegion: 4 }],
        //   TipoRuta: ['FR', 'P', 'R'],
        //   DiaVisita: ['L', 'M',  'X', 'J', 'V', 'S', 'D'],
        //   FrecuenciaRuta: ['M1', 'M2', 'M3', 'M4', 'Q1', 'Q2', 'S1', 'S2', 'S3', 'S4']
        // };
      }
    });
  }

  ClosePanel() {
    this.territoriesService.setVisiblePanelTerritories(false);
  }

  onCardCheckboxClicked(item: TerritoriesListItem, event: Event) {
    event.stopPropagation();

    if (this.selectedItems.size >= 3 && !this.selectedItems.has(item.idTerritory)) {
      this.toastService.warning("Solo puedes seleccionar hasta 3 territorios para comparar.");
      return;
    }
    const territoryId = item.idTerritory;
    
    const newSet = new Set(this.selectedItems);
    if (newSet.has(territoryId)) {
      newSet.delete(territoryId);
    } else {
      newSet.add(territoryId);
    }
    this.selectedItems = newSet;
    console.log("TerritoriesList", this.selectedItems);
    
  }

  removeSelectedItem(territoryId: string) {
    const newSet = new Set(this.selectedItems);
    newSet.delete(territoryId);
    this.selectedItems = newSet;
  }

  onCardDetailsClicked(item: TerritoriesListItem, event: Event) {
    event.stopPropagation();
    this.panelTerritoriesService.setLoading(true);
    if (!environment.production) console.log("Card Clicked", item);

    if(item.routeType == null || item.zone == null || item.visitDay == null || item.routeFrequency == null){
      this.toastService.warning("Territorio con información incompleta.");
      this.panelTerritoriesService.setLoading(false);
      return;
    }

    this.fullScreen = false;
    this.resetCentroidsGeoJson();
    this.UpdateDetailTerritory(item, !this.areFiltersSelected);
  }

  UpdateDetailTerritory(item: TerritoriesListItem, isStandAlone: boolean) {
    this.panelDetailTerritoriesService.setData(item, isStandAlone);
    this.territoriesService.setVisiblePanelDetailTerritories(true);
    this.panelTerritoriesService.setLoading(false);
  }

  openFilterTerritoriesDialog(){
    if(this.isLoadingFilters){
      return;
    }
    const filterData:{ filterData: TerritoriesFilters, selectedFilters: TerritoriesFiltersSelected } = {
      filterData: this.territoriesFilters,
      selectedFilters: this.selectedFilters
    };

    this.filterDialog = this.matDialog.open(TerritoriesFilterPopupComponent, {
      maxWidth: "100vw",
      maxHeight: "100vh",
      panelClass: 'territories-filter-overlay',
      autoFocus: false,
      restoreFocus: false,
      hasBackdrop: false,
      disableClose: true,
      data: filterData,
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '200ms'
    });

    this.filterDialog.afterClosed().subscribe(result => {
      if(result){
        if(result.search){

          this.selectedFilters = result.selectedFilters;
          if(!environment.production) console.log('filtros', result.selectedFilters, this.selectedFilters);
          
          if(this.$Items.length > this.$ItemsNoFilterBackup.length)
            this.$ItemsNoFilterBackup = [...this.$Items];

          if(this.centroidesGeoJsonBackup == null || this.centroidesGeoJsonBackup.features.length < this.centroidesGeoJson.features.length){
            this.centroidesGeoJsonBackup = JSON.parse(JSON.stringify(this.centroidesGeoJson));
          }

          this.getTerritoriesList(this.selectedFilters);

        }
      }
    });

  }

  CountRouteTypes(){
    this.itemsCounter = {};
    this.$Items.forEach(item => {
      this.itemsCounter[item.routeType] = (this.itemsCounter[item.routeType] || 0) + 1;
    });
  }


  openEditTerritories(){
    event.stopPropagation();
    const items = this.$ItemsBackup.filter(item => this.selectedItems.has(item.idTerritory));
    this.panelTerritoriesService.setLoading(true);
    if (!environment.production) console.log("edit Clicked", items);

    if(items.some(item => item.routeType == null || item.zone == null || item.visitDay == null || item.routeFrequency == null)){
      this.toastService.warning("No se pueden editar territorios si falta información en alguno.");
      this.panelTerritoriesService.setLoading(false);
      return;
    }

    this.fullScreen = false;
    this.resetCentroidsGeoJson();
    this.updateEditTerritory(items);
  }

  updateEditTerritory(items: TerritoriesListItem[]) {
    this.panelEditTerritoriesService.setData(items);
    this.territoriesService.setVisiblePanelEditTerritories(true);
    this.panelTerritoriesService.setLoading(false);
  }

  loadCentroidsGeoJson(geoJson: any){
    const geoJsonCentroids = geoJson;
    geoJsonCentroids.features.forEach(feature => {
      (feature.properties as any).icon = this.routeTypeIconPipe.transform(feature.properties.RouteType);
    });
    console.log("geoJson centroides", geoJsonCentroids);
          
    this.panelTerritoriesService.loadCentroidGeoJson(geoJsonCentroids);
  }

  resetCentroidsGeoJson(){
    this.panelTerritoriesService.resetCentroidGeoJson();
  }









  //------------------ filtros (de momento no se usarán) ------------------

  // togglePolygonFilter(idTerritory: string, event: Event) {
  //   event.stopPropagation();
  //   const isShownPolygon = this.layerTerritoriesService.filtroDeTerritorios[idTerritory]?.visiblePolygon;
  //   if(isShownPolygon){
  //     this.panelTerritoriesService.removeActiveTerritoryPolygonFilter(idTerritory);
  //   }else{
  //     this.panelTerritoriesService.addActiveTerritoryPolygonFilter(idTerritory);
  //   }
  //   this.AreAllLayerFiltersActive(this.layerTerritoriesService.filtroDeTerritorios);
  // }

  // toggleLocationsFilter(idTerritory: string, event: Event) {
  //   event.stopPropagation();
  //   const isShownLocations = this.layerTerritoriesService.filtroDeTerritorios[idTerritory]?.visibleLocations;
  //   if(isShownLocations){
  //     this.panelTerritoriesService.removeActiveTerritoryLocationFilter(idTerritory);
  //   }else{
  //     this.getLocationsForTerritory(idTerritory);
  //     this.panelTerritoriesService.addActiveTerritoryLocationFilter(idTerritory);
  //   }
  //   this.AreAllLayerFiltersActive(this.layerTerritoriesService.filtroDeTerritorios);
  // }

  // getLocationsForTerritory(idTerritory: string){
  //     this.isLoading = true;

  //   if(this.panelTerritoriesService.locationsGeoJson[idTerritory]){
  //     const pointGeoJson = this.panelTerritoriesService.locationsGeoJson[idTerritory];
  //     this.panelDetailTerritoriesService.loadMoreLocationGeoJson(pointGeoJson);
  //     this.isLoading = false;
  //     return;
  //   }

  //   const dataGeoJsonFeatures = this.dummyDataGeoJson.features.filter(feature => feature.properties.idTerritory === idTerritory) || [...this.dummyDataGeoJson.features.filter(feature => feature.properties.idTerritory === "FRJQ1_MON")];
    
  //   dataGeoJsonFeatures.forEach(feature => {
  //     feature.properties.idTerritory = idTerritory;
  //     (feature.properties as any).color = this.panelDetailTerritoriesService.assignColor(idTerritory);
  //   });
  //   const pointGeoJson ={
  //     type: "FeatureCollection",
  //     features: dataGeoJsonFeatures
  //   }
  //   this.panelDetailTerritoriesService.loadMoreLocationGeoJson(pointGeoJson);
  //   this.panelTerritoriesService.locationsGeoJson[idTerritory] = pointGeoJson;
  //   this.isLoading = false;
  // }

  // AreAllLayerFiltersActive(filtros: { [key: string]: { visiblePolygon: boolean, visibleLocations: boolean } }): boolean {
  //   const keys = Object.keys(filtros).filter(territoryId => this.$Items.some(item => item.idTerritory === territoryId));
  //   if (keys.length === 0) {
  //     this.areAllLayerFiltersActive = true;
  //     console.log("layersActive", this.areAllLayerFiltersActive);
      
  //     return;
  //   }
  //   this.areAllLayerFiltersActive = keys.every(key => filtros[key].visiblePolygon && filtros[key].visibleLocations)
  //     console.log("layersActive", this.areAllLayerFiltersActive);
  // }

  // activateAllFilters(filtros: { [key: string]: { visiblePolygon: boolean, visibleLocations: boolean } }): void {
  //   const activeFiltros = Object.keys(filtros).filter(territoryId => this.$Items.some(item => item.idTerritory === territoryId));
  //   if (this.areAllLayerFiltersActive) {
  //     // this.panelTerritoriesService.removeFilters();
  //     // this.areAllLayerFiltersActive = false;
  //     return;
  //   }
  //   activeFiltros.forEach(territoryId => {
  //     if (!filtros[territoryId].visiblePolygon) {
  //       this.panelTerritoriesService.addActiveTerritoryPolygonFilter(territoryId);
  //     }
  //     if (!filtros[territoryId].visibleLocations) {
  //       this.getLocationsForTerritory(territoryId);
  //       this.panelTerritoriesService.addActiveTerritoryLocationFilter(territoryId);
  //     }
  //   });
  //   this.AreAllLayerFiltersActive(this.layerTerritoriesService.filtroDeTerritorios);
  // }

  // ActivateFilteredLayersAfterGlobalFilter(filtrosBackUp: { [key: string]: { visiblePolygon: boolean, visibleLocations: boolean } }): void {
  //   const activeFiltros = Object.keys(filtrosBackUp).filter(territoryId => this.$Items.some(item => item.idTerritory === territoryId));

  //   activeFiltros.forEach(territoryId => {
  //     if (filtrosBackUp[territoryId].visiblePolygon) {
  //       this.panelTerritoriesService.addActiveTerritoryPolygonFilter(territoryId);
  //     }
  //     if (filtrosBackUp[territoryId].visibleLocations) {
  //       this.getLocationsForTerritory(territoryId);
  //       this.panelTerritoriesService.addActiveTerritoryLocationFilter(territoryId);
  //     }
  //   });
  //   this.AreAllLayerFiltersActive(this.layerTerritoriesService.filtroDeTerritorios);
  // }

  
}